import Button from './button/Button';

interface SuiteUITabsProps {
    tabs: { label: string; value: string; hidden?: boolean }[];
    activeTab: string;
    setActiveTab: (val: string) => void;
}

const SuiteUITabs = ({ tabs, activeTab, setActiveTab }: SuiteUITabsProps) => {
    return (
        <div className='flex gap-2'>
            {tabs.map(
                (item) =>
                    !item.hidden && (
                        <Button
                            key={item.value}
                            variant={
                                item?.value === activeTab
                                    ? 'primaryInvert'
                                    : 'tertiaryOutline'
                            }
                            onClick={() => setActiveTab(item?.value)}
                            text={item?.label}
                            type='button'
                        />
                    )
            )}
        </div>
    );
};

export default SuiteUITabs;
